import { provideWidgetClass } from "scrivito"

export const ProjectOpportunityWidget = provideWidgetClass(
  "ProjectOpportunityWidget",
  {
    attributes: {
      data: "datalocator",
      content: "widgetlist",
      emptyContent: "widgetlist"
    }
  }
)
